import React from "react"
import { makeStyles, Slide, Typography, Zoom } from "@material-ui/core"
import InfoItem from "../InfoItem"
import image from '../../../../../../../assets/Home/IMAGEN-DIGITAL-THERAP.png'
import WorkModal from "../WorkModal"



const Digital = ({open, onClose}) => {

    const classes = useStyles()

    return(
        <WorkModal open={open} onClose={onClose} >
            <div className={classes.root} >
                <Typography variant='h3' className={classes.title} >Digital Therapeutics</Typography>
                <Zoom in timeout={750} style={{ transitionDelay:'500ms' }}>
                <div className={classes.challenge}>
                    <InfoItem 
                        title='Challenge.'
                        info='Help our client to increase the self-monitoring practice 
                        in pediatric patients with type 1 diabetes.'
                    />
                </div>
                </Zoom>
                <Zoom in timeout={750} style={{ transitionDelay:'1000ms' }}>
                <div className={classes.solution}>
                    <InfoItem 
                        title='Solution.'
                        info='ālthar technology team designs an evidence-based 
                        therapeutic intervention driven by high-quality software 
                        and a simple pediatric-focus UX, to increase 
                        self-monitoring, prevent complications, and also teach 
                        little patients how to manage their condition.'
                    />
                </div>
                </Zoom>
                <Zoom in timeout={750} style={{ transitionDelay:'1500ms' }} >
                <div className={classes.result}>
                    <InfoItem 
                        title='Result.'
                        info='An improvement of 47% in adherence to self-monitoring 
                        practice.'
                    />
                </div>
                </Zoom>
                <Slide direction="up" in timeout={1000} >
                    <div className={classes.img_container}>
                        <img src={image} width={'100%'} className={classes.img} />
                    </div>
                </Slide>
            </div>
        </WorkModal>
    )
}

export default Digital

const useStyles = makeStyles(theme => ({
    root:{
      position:'relative',
      //padding:70,
      color:'white',
      textAlign:'right',
      alignItems:'end',
      display:'flex',
      flexDirection:'column',
      [theme.breakpoints.down('sm')]:{
        //padding:32,
        textAlign:'left',
        alignItems:'start'
        //display:'initial'
        }
    },
    title:{
        textAlign:'right',
        marginBottom:20,
        [theme.breakpoints.down('sm')]:{
            fontSize:'2.5rem',
            textAlign:'center',
            //background:'red',
            width:'100%',
            marginTop:40,
            }
    },
    challenge:{
        maxWidth:520,
        marginTop:20,
        [theme.breakpoints.only('md')]:{
            maxWidth:400
            },
        [theme.breakpoints.down('sm')]:{
            maxWidth:'100%'
            }
  
    },
    result:{
        maxWidth:520,
        marginTop:20,
        [theme.breakpoints.only('md')]:{
            maxWidth:400
            },
        [theme.breakpoints.down('sm')]:{
            maxWidth:'100%'
            }
     
    },
    solution:{
        maxWidth:520,
        marginTop:20,
        [theme.breakpoints.only('md')]:{
            maxWidth:400
            },
        [theme.breakpoints.down('sm')]:{
            maxWidth:'100%'
            }
      
    },
    img:{
        //transform:'rotate(-12deg) scale(1.2)',
        [theme.breakpoints.down('md')]:{
            transform:'scale(0.8)',
        },
        /* [theme.breakpoints.down('sm')]:{
            transform:'rotate(4deg) scale(0.8)',
            //background:'pink'
        }, */
    },
    img_container:{
        position:'absolute',
        top:60,
        left:'20%',
        [theme.breakpoints.down('lg')]:{
            left:'5%'
        },
        [theme.breakpoints.down('md')]:{
            left:0,
            //background:'red',
        },
        [theme.breakpoints.down('sm')]:{
            left:0,
            position:'relative',
            top:0,
            left:'initial',
            margin:'auto',
            //height:700,
            //background:'blue'
        }
    },
    line:{
        position:'absolute',
        border:'1px solid white',
        [theme.breakpoints.down(1670)]:{
            display:'none'
        },
    }

  }))



